<template>
  <footer class="zui-footer">
    <div class="container footer_box" style="display: flex; flex-wrap: wrap">
      <div class="item lxwm" style="color: white; margin-left: 50px">
        <p class="title" style="">友情链接</p>
        <div style="display: flex">
          <div>
            <!-- <p class="email">
              <a href="http://www.80580.net/" style="margin-right: 20px">电子保函公共资源交易中心</a>
            </p>
            <p class="email">
              <a href="https://www.spdb.com.cn/" style="margin-right: 20px">电子保函数据综合服务平台</a>
            </p> -->
            <p class="email">
              <a href="javascript:;" @click="goweb('https://www.ggzy.gov.cn/')" style="margin-right: 20px">国家公共资源交易服务平台</a>
            </p>
            <p class="email">
              <a href="javascript:;" @click="goweb('https://ggzyfw.fujian.gov.cn/')" style="margin-right: 20px">福建省公共资源中心</a>
            </p>
            <p class="email">
              <a href="javascript:;" @click="goweb('https://smggzy.sm.gov.cn/smwz/')" style="margin-right: 20px">三明市公共资源交易中心</a>
            </p>
          </div>
        </div>
      </div>
      <div class="item lxwm lx_phone" style="color: white;margin-left: 107px;">
        <p class="title" style="color: white;">联系电话</p>
        <p class="phone">客服电话：{{ Info.customerMobile }}</p>
        <!-- <p>商务合作：{{ Info.businessMobile }} {{ Info.businessName }}</p> -->
        <p class="email">公司地址：{{ Info.address }}</p>
      </div>
      <div class="item lxwm lx_phone" style="color: white;margin-left: 157px;">
        <p class="title" style="color: white;">诉讼保函小程序</p>
        <img src="../assets/img/xcx.jpg" alt="" style="width: 100px;height: 100px;margin-left: 25px;">
        <!-- <p>商务合作：{{ Info.businessMobile }} {{ Info.businessName }}</p> -->
      </div>
    </div>
    <div class="links" style="margin-top: 50px">
      <a href="javascript:;" @click="go('/')">首页</a>
      <a href="javascript:;" @click="go('Guarantee')">保函产品</a>
      <a href="javascript:;" @click="go('about')">助贷服务</a>
      <a href="javascript:;" @click="go('info')">资讯中心</a>
      <a href="javascript:;" @click="go('help')">保函查验</a>
      <a href="javascript:;" @click="go('Business','6')">注册登录</a>
    </div>
    <p class="copy-right" style="color: #888888;">
      @ 2025 三明市保函信息科技有限公司版权所有备案号：<a style="color: #888888;" href="https://beian.mps.gov.cn/#/query/webSearch">{{ Info.gabNo }}</a> <span style="margin-left: 5px;"><a style="color: #888888;" href="https://beian.miit.gov.cn/">{{ Info.gxbNo }}</a></span>
     
      <br />
      <span>今日浏览人次:{{ Info1.indexDailyCount }}次</span><span>， 累计浏览人次:{{ Info1.indexHistoryCount }}次</span>
      <br />
      声明:本平台仅提供技术支持，所有保函产品均由出具保函的金融机构提供，所有销售、理赔等服务均由本平台合作的金融机构提供
    </p>
  </footer>
</template>
<script>
import "./less/footer.less";
import { indexAccess,indexCenterInfo } from "../api/user.js";
export default {
  data() {
    return {
      phone:window.SITE_CONFIG.phone,
      Bah:window.SITE_CONFIG.Bah,
      Info:{},
      Info1:{}
    };
  },
  mounted(){
    this.getindexAccess()
    this.getindexCenterInfo()
  },
  methods: {
    goweb(n){
      window.open(n)
    },
    getindexCenterInfo(){
      indexCenterInfo().then(res=>{
        console.log(res.data)
        this.Info = res.data
      })
    },  
    getindexAccess(){
      indexAccess().then(res=>{
        console.log(11111)
        this.Info1 = res.data
      })
    },
    go(n,e) {
      if(e=="6"){
           window.open(this.$Url +  '/social-login')
        }else{
          this.$router.push({
            path: n,
          });
        }
    
    },
  },
};
</script>
<style scope>
#aui-footer .footer_box {
  display: flex;
  justify-content: space-between;
  color: white;
}
.item p {
  color: white;
}
.email a {
  font-size: 14px;
font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
font-weight: 500;
color: #888888;
line-height: 20px;
}
.email a:hover{
  color: white;
}
.lx_phone>p{
  color: #888888;
}
@media screen and (min-width: 1024px) and (max-width: 3920px) {
  .title {
    margin-bottom: 22px;
    font-weight: 500;
    font-size: 22px;
  }
}

@media screen and (min-width: 320px) and (max-width: 768px) {
  .title {
    margin-bottom: 22px;
    font-size: 20px;
  }
  .item {
    margin-top: 50px;
    margin-left: 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue